/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Ccsl_TitleInputs */



/**
* | output |
* | --- |
* | "CCSL" |
*
* @param {File_Export_Ccsl_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_ccsl_title = /** @type {((inputs?: File_Export_Ccsl_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Ccsl_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("CCSL")
	if (locale === "de") return /** @type {LocalizedString} */ ("CCSL")
	if (locale === "it") return /** @type {LocalizedString} */ ("CCSL")
	if (locale === "ru") return /** @type {LocalizedString} */ ("CCSL")
	if (locale === "es") return /** @type {LocalizedString} */ ("CCSL")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("CCSL")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CCSL")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सीसीएसएल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("CCSL")
	return /** @type {LocalizedString} */ ("CCSL")
});